<template>
    <div class="cue-word-loading" v-if="loading">
        <div class="loading-container">
            <div class="loading-bar-box">
                <div class="loading-bar">
                    <div class="loading-bar-inner" :style="loadingBarStyle">
                        <div class="point"></div>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
export default {
    name: "CueWordLoading",
    data() {
        return {
            // 进度
            progress: 0,
            loading: false,
            intervalId: null,
        }
    },
    computed: {
        // 进度条背景色根据进度动态变化
        loadingBarStyle() {
            return {
                width: `${this.progress}%`,
            }
        }
    },
    methods: {
        show() {
            this.loading = true;
            this.progress = 0
            this.increaseProgress(8);
        },
        hide() {
            
            this.progress = 100;
            clearInterval(this.intervalId);

            setTimeout(() => {
                this.loading = false;
            }, 800);
        },
        // 每秒增加进度，随机增加，根据传入的速度增加进度，进度最大为100
        increaseProgress(speed) {
            // 每秒增加进度
            this.intervalId = setInterval(() => {
                this.progress += Math.floor(Math.random() * 10) * speed;
                if (this.progress >= 95) {
                    clearInterval(this.intervalId);
                }
            }, 1000);
        }
    }
}
</script>

<style lang="less" scoped>
.cue-word-loading {
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    z-index: 9999;
    left: 0;
    top: 0;
}

.loading-container {
    width: 280px;
    height: 229px;
    background: url('https://static.ycsd.work/collocation-helper/ast/cue-word-loading-bg.png') no-repeat center center;
    background-size: 100% 100%;
    position: relative;

    .loading-bar-box {
        width: 240px;
        height: 22px;
        border-radius: 47px;
        border: 1px solid rgba(94, 192, 223, 0.1);
        position: absolute;
        left: 20px;
        bottom: 36px;

        .loading-bar {
            width: 232px;
            height: 16px;
            border-radius: 45px;
            position: absolute;
            top: 2px;
            left: 2px;

            .loading-bar-inner {
                min-width: 16px;
                height: 16px;
                border-radius: 45px;
                background: linear-gradient( 90deg, rgba(94,192,223,0) 0%, #46BADF 100%);
                transition: width 0.3s ease-in-out;
                position: relative;
                .point {
                    width: 16px;
                    height: 16px;
                    background: #46BADF;
                    border-radius: 50%;
                    position: absolute;
                    top: 0;
                    right: 0;
                }
            }
        }
    }
}
</style>